import {
  VStack,
  Heading,
  Text,
  SimpleGrid,
  GridItem,
  FormControl,
  FormLabel,
  useColorModeValue,
  useBreakpointValue,
  Box,
  Button,
} from "@chakra-ui/react";
import React, { Dispatch, SetStateAction } from "react";
import { generatePrizeGroup } from "../utils/generatePrizeGroup";

const ComputedResult = ({
  score,
  prizeMoney,
  setIsComputed,
  setScore,
  setPrizeMoney,
}: {
  score: number;
  prizeMoney: string;
  setIsComputed: Dispatch<SetStateAction<any>>;
  setScore: Dispatch<SetStateAction<any>>;
  setPrizeMoney: Dispatch<SetStateAction<any>>;
}) => {
  const bgColor = useColorModeValue("gray.50", "whiteAlpha.50");
  const colSpan = useBreakpointValue({ base: 4, md: 2 });

  const handleOnReturn = () => {
    setIsComputed(false);
    setScore(0);
    setPrizeMoney("");
  };

  return (
    <VStack
      w="full"
      h="full"
      p={10}
      spacing={6}
      alignItems="flex-start"
      bg={bgColor}
    >
      <VStack spacing={3} alignItems="flex-start">
        <Heading size="2xl">Your Results!</Heading>
      </VStack>
      <SimpleGrid columns={12} columnGap={3} rowGap={6} w="full">
        <GridItem colSpan={12}>
          <FormControl>
            <FormLabel>Numbers matched:</FormLabel>
            <GridItem colSpan={colSpan}>
              <Box bg="whiteAlpha.50" w="100%" h="100%" borderRadius="lg">
                <Text fontSize="4xl" textAlign="center">
                  {score}
                </Text>
              </Box>
            </GridItem>
          </FormControl>
        </GridItem>
      </SimpleGrid>

      {score >= 3 ? (
        <>
          <Heading size="2xl">You've won {prizeMoney}!</Heading>
          <Heading size="sm">
            Your prize group is Group {generatePrizeGroup(score) + 1}
          </Heading>

          <Text></Text>
        </>
      ) : (
        <Heading size="2xl">You did not win, better luck next time!</Heading>
      )}
      <Button onClick={handleOnReturn} size="lg" w="full">
        Back to home
      </Button>
    </VStack>
  );
};

export default ComputedResult;
